// MyAccountSkeleton — HOTFIX (flash de cor). Placeholder NEUTRO (cinza, sem
// brand_color, sem dourado, sem azul) mostrado só enquanto o GET /public/:slug
// da empresa ainda não respondeu. Assim que a resposta chega, MyBookingsPage
// troca para o MyAccountV2 real já com a cor definitiva — nunca há um frame
// intermediário pintado com a cor de outra empresa ou com o fallback dourado.
import React from 'react';
import { Box, Skeleton } from '@mui/material';

export function MyAccountSkeleton() {
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#f7f8fa', pb: 'env(safe-area-inset-bottom, 16px)' }}>
      <Box sx={{ bgcolor: '#fff', borderBottom: '1px solid #eeeeee', px: 2, pt: 'env(safe-area-inset-top, 0px)' }}>
        <Box sx={{ maxWidth: 560, mx: 'auto', display: 'flex', alignItems: 'center', gap: 1.2, py: 1.2, minHeight: 44 }}>
          <Skeleton variant="circular" width={32} height={32} />
          <Box sx={{ flex: 1 }}>
            <Skeleton variant="text" width="40%" height={20} />
          </Box>
        </Box>
      </Box>
      <Box sx={{ maxWidth: 560, mx: 'auto', px: 2, pt: 2 }}>
        <Skeleton variant="text" width="35%" height={22} sx={{ mb: 1.5 }} />
        <Skeleton variant="rounded" height={48} sx={{ mb: 2, borderRadius: 2.5 }} />
        <Skeleton variant="rounded" height={40} sx={{ mb: 2, borderRadius: 2.5 }} />
        <Skeleton variant="rounded" height={90} sx={{ mb: 1.5, borderRadius: 3 }} />
        <Skeleton variant="rounded" height={90} sx={{ borderRadius: 3 }} />
      </Box>
    </Box>
  );
}
